<!-- PrivacyModal.vue -->
<template>
  <div class="modal-container">
    <img
      src="images/close.svg"
      class="close"
      @click="resetModal"
      role="button"
      aria-label="Close"
      alt="X to close modal"
      title="Close"
    />
    <div class="modal-content">
      <h1>Privacy and Local Storage Notice</h1>
      <div class="modal-main">
        <p>
          We value your privacy and want to be transparent about how we use and
          collect your game stats during this playtesting phase.
        </p>
        <p>
          <strong>How We Use Data:</strong> During playtesting, we collect and
          send data about your game stats to our server. This helps us analyze
          what works and what doesn't in the game so we can improve the
          experience. Your data will be used solely for this purpose and is not
          shared with third parties.
        </p>
        <p>
          <strong>What We Collect:</strong> We collect data related to your game
          stats. This includes information like the number of sequences found,
          puzzle completion time, and hint usage, which will be sent to our
          server for analysis.
        </p>
        <p>
          <strong>Your Consent:</strong> By participating in this playtest, you
          consent to the collection and transmission of your game stats to our
          server. This is necessary to help us refine and improve the game.
        </p>
        <p>
          <strong>Data Management:</strong> While you cannot opt out of sending
          stats during playtesting, this data is only used for evaluating game
          performance and improving features. If you have concerns about the
          data being collected, please reach out to Michael.
        </p>
        <p>
          <strong>Note:</strong> Clearing your local storage and refreshing the
          page will erase your streak and progress on your device, but we will
          still have the game stats already sent to the server for analysis.
        </p>
        <p class="centered-text">Thank you for playing!</p>
      </div>
      <div class="modal-options">
        <div class="modal-option-label">Allow Local Storage</div>
        <label class="switch">
          <input type="checkbox" v-model="toggleValue" />
          <span class="slider"></span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyModal",
  props: {
    resetModal: {
      type: Function,
      required: true,
    },
    saveProgress: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      toggleValue: this.saveProgress,
    };
  },
  watch: {
    toggleValue(value) {
      this.$emit("toggled", "saveProgress", value);
    },
  }
};
</script>

<style scoped>
</style>